import React, { useState } from "react";
import { StyledTableCell } from "../../../shared/components/CustomTable/Styled";
import { IconButton, ListItem, ListItemText, TableRow } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Template from "../../../templates/phieu_nhap_kho_san_pham.docx";
import { generateDocument, generateDocumentBlob } from "../../../utils/exportUtils";
import { buildDocxData } from "../../../utils/docxBuilder";
import { productImportHistoryDownloadDescriptor } from "../../../utils/docxMappings";
import ListView from "../../../shared/components/ListView";
import { ProductsImportFilterType } from "../../../configs/filterTypes";
import { ProductsImportSortTypes } from "../../../configs/sortTypes";
import { ProductImportInfo } from "../../../data/entities";
import { ItemList as ProductImportList, ItemListItem as ProductImportListItem, ItemListItemQuantity as ProductImportListItemQuantity } from "../../../shared/styled/ListItemStyles";
import DocxPreviewModal from "../../../shared/components/DocxPreviewModal";
import DownloadIcon from "@mui/icons-material/Download";
import { StyledButton } from "../../../shared/styled/TitleBar";
import { formatProductImportHistoryDate } from "./dateFormatting";
import ProductHistoryDeepLinkPreview from "../ProductHistoryDeepLinkPreview";

const ProductImportHistoryTableColumns = [
    {
        text: 'Mã phiếu',
        icon: <></>
    },
    {
        text: 'Khách hàng',
        icon: <></>
    },
    {
        text: 'Người giao',
        icon: <></>
    },
    {
        text: 'Phương thức nhập',
        icon: <></>
    },
    {
        text: 'Sản phẩm nhập',
        icon: <></>
    },
    {
        text: 'Ghi chú',
        icon: <></>
    },
    {
        text: 'Ngày tạo',
        icon: <></>
    },
    {
        text: 'Ngày nhập kho',
        icon: <></>
    },
    {
        text: 'Xem trước',
        icon: <></>
    },
];


interface ProductImportHistoryRowProps {
    item: ProductImportInfo;
    extraRowProps: any;
}

const ProductImportHistoryRow = ({ item, extraRowProps }: ProductImportHistoryRowProps) => {
    const itemDate = new Date(item.import_date);
    const exportData = buildDocxData(item, productImportHistoryDownloadDescriptor);

    const onClickDownload = () => {
        generateDocument(exportData, Template, `phieu_nhap_kho_${itemDate.toLocaleDateString('en-GB')}`);
    }

    const [previewBlob, setPreviewBlob] = useState<Blob | null>(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const onClickPreview = () => {
        generateDocumentBlob(exportData, Template).then((blob) => {
            console.debug("Generated DOCX blob for preview", { size: blob.size, type: blob.type });
            setPreviewBlob(blob);
            setIsPreviewOpen(true);
        });
    }


    return (
        <>
            <TableRow>
            <StyledTableCell>{item.import_code}</StyledTableCell>
            <StyledTableCell>{item.customer?.name}</StyledTableCell>
            <StyledTableCell>{item.receiver_name}</StyledTableCell>
            <StyledTableCell>{item.import_method}</StyledTableCell>
            <StyledTableCell>
                <ProductImportList>
                    {item.products.map((product, index) => (
                        <ListItem 
                            key={product.product.id || index}
                            dense
                            disableGutters
                            style={{ padding: '2px 0' }}
                        >
                            <ListItemText
                                primary={
                                    <ProductImportListItem>        
                                        <span>{product.product.name}</span>
                                        <ProductImportListItemQuantity>
                                            x{product.quantity}
                                        </ProductImportListItemQuantity>
                                    </ProductImportListItem>
                                }
                            />
                        </ListItem>
                    ))}
                </ProductImportList>
            </StyledTableCell>
            <StyledTableCell>{item.note}</StyledTableCell>
            <StyledTableCell>{formatProductImportHistoryDate(item.created_at)}</StyledTableCell>
            <StyledTableCell>{formatProductImportHistoryDate(item.import_date)}</StyledTableCell>
            <StyledTableCell>
                <IconButton onClick={onClickPreview} title="Xem trước phiếu">
                    <VisibilityIcon />
                </IconButton>
            </StyledTableCell>
        </TableRow>
        
        <DocxPreviewModal
            open={isPreviewOpen}
            onClose={() => setIsPreviewOpen(false)}
            blob={previewBlob}
            title="Xem trước phiếu nhập kho thành phẩm"
            debug={false}
            actions={
                <StyledButton
                    variant="outlined"
                    onClick={onClickDownload}
                >
                    <DownloadIcon style={{ marginRight: '8px' }} />
                    Tải phiếu
                </StyledButton>
            }
        />
        </>
    );
};

const ProductImportHistory = () => {
    return (
        <>
        <ListView
            url="/products/import/"
            filterTypes={ProductsImportFilterType}
            sortTypes={ProductsImportSortTypes}
            rowElement={ProductImportHistoryRow}
            tableColumns={ProductImportHistoryTableColumns}
            textString={"Tìm kiếm theo tên khách hàng, mã phiếu nhập kho"}
        />
        <ProductHistoryDeepLinkPreview kind="import" />
        </>
);
};

export default ProductImportHistory;
